// CSS Modules - component class name: FormTextarea__

<template>
  <div :class="[$style.container, { FormTextarea__error: this.error }]">
    <label
      :class="[
        $style.label,
        {
          FormTextarea__optional: this.optionalLabel
        }
      ]"
      :for="formTextareaId"
    >
      {{ label }}
      <span v-if="optionalLabel">({{ optionalLabel }})</span>
    </label>
    <textarea
      :id="formTextareaId"
      :rows="rows"
      :columns="columns"
      :value="value"
      @input="handleInput"
      :aria-label="ariaLabel"
    ></textarea>
    <div v-if="error" :class="$style.errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";

export default {
  name: "FormInput",
  props: {
    value: String,
    label: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 1
    },
    optionalLabel: String,
    ariaLabel: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      formTextareaId: uuidv4()
    }
  },
  methods: {
    handleInput($event) {
      this.$emit("input", $event.target.value);
    }
  }
};
</script>

<style module lang="scss">
@import "./FormTextarea.scss";
</style>
